<template>
  <div id="car">
    <van-tabs color="#887BFF" swipe-threshold="3" v-model="active_top" @click="shop_type">
      <van-tab :title="$t('column.Car')" name="car">
        <template>
          <div>
            <car ref="car_son"></car>
          </div>
        </template>
      </van-tab>
      <van-tab :title="$t('column.avatar_frame')" name="avatar_frame">
        <template>
          <div>
            <avatar_frame ref="avatar_frame"></avatar_frame>
          </div>
        </template>
      </van-tab>
      <van-tab :title="$t('column.beautiful_horn')" name="luck">
        <template>
          <div>
            <luck ref="luck_son"></luck>
          </div>
        </template>
      </van-tab>
      <van-tab :title="$t('column.VIP_members')" name="vip">
        <template>
          <div>
            <vip ref="vip_son"></vip>
          </div>
        </template>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>

    import '@/assets/css/style.css'
    import vip from './vip'                                //vip子元素
    import car from './car'                                //坐骑子元素
    import luck from './luck'                           //靓号子元素
    import avatar_frame from './avatar_frame'           // 头像框

    export default {
        data() {
            return {
                active_top: 'car',
                active: 1,
                list: [],
                vip_rule: [],
                user: []
            }
        },
        created: function () {
            document.title = this.$t('title.shop','en_us')
        },
        components: {
            vip,
            car,
            luck,
          avatar_frame
        },
        methods: {
            shop_type(name, title) {
                if (name === 'vip') {

                } else if (name === 'car') {

                } else {

                }
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/shop.vue